import Vue from "../main";
import { getReviewService, writeReviewService } from "../services/reviewService";

export async function getProductReviews(productId, perPage = 10, currentPage = 1) {
  const {
    $toast,
  } = Vue._context.config.globalProperties;

  try {
    const res = await getReviewService({
        "prodottoId": productId,
        "limit": perPage,
        "page": currentPage
      });
    
    return res;
    
  } catch (error) {
    let message = "An error has occurred.";
    if (error.message) {
      message = error.message;
    }
    $toast.error(message);
    return "";
  }
}

export async function addProductReview(productId, review) {
  const {
    $toast,
  } = Vue._context.config.globalProperties;

  try {
    const res = await writeReviewService({
        "prodottoId": productId,
        "voto": review.voto,
        "messaggio": review.messaggio
    });
    if (!res || res.error) {
      throw new Error(res.message || "Failed to write review.");
    }
    $toast.success("Review submitted successfully!");
    return true;
  } catch (error) {
    let message = "An error has occurred.";
    if (error.message) {
      message = error.message;
    }
    $toast.error(message);
    return "";
  }
}
